var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{staticClass:"resume-link",attrs:{"href":"https://ronngb.github.io/resume/","target":"_blank"}},[_vm._v(" resume ")])])}]

export { render, staticRenderFns }